import React, { useEffect, useRef, useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import styled, { useTheme } from 'styled-components/native'
import { Icon } from './index';
import { Grid, PieChart, StackedBarChart, XAxis, YAxis } from 'react-native-svg-charts'

import * as _ from 'lodash';
import {COLORS} from '../WasteTheme';
import * as scale from 'd3-scale'
import moment from 'moment';
import {BasicText, FlexBlock, StrongText} from './Styles'

import { G, Svg, Text } from 'react-native-svg';
import { TSpan, Text as SVGText } from 'react-native-svg';
import Util from './core/Util';
import InputSelect from './core/InputSelect';
import { Bound, useMagic } from 'opidcore';

//TODO Will need to move this into a "state like thing" after login or from the portal data.
const window = {
	PORTAL_COUNTRY: "Canada",
};

//TODO will need to determine which of these are safe to bring into componenets we want to keep
const ViewStatBlock = styled.View`
	min-width: 85px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 22px;
`;

const StatLabel = styled.Text`
    padding-left: 10px;
    font-size: 16px;
    color: #4D4D4F;
    font-weight: 400;
`;

const StatValue = styled.Text`
    padding-left: 10px;
    font-size: 18px;
    color: #4D4D4F;
    font-weight: 400;
`;

const StatUnits = styled.Text`
    padding-left: 10px;
    color: #4D4D4F;
    font-size: 12px;
    font-weight: 400;
`;

const StyledLink = styled.View`
	color: #00bacd;
	border-bottom-width: 2px;
	border-bottom-color: rgba(0,244,344,0.4);
`;

export function StatBlock({value, color, icon, label, symbol, units, fType}){
	let displayValue = Number(value).toLocaleString();

	if (symbol == "$"){
		displayValue = Format.asCurrency(value);
		if (displayValue.indexOf("$") == -1){
			displayValue = "$" + displayValue;
		}
	}

	if (units == "MT" && window.PORTAL_COUNTRY == "USA"){
		units = "Tons";
	}

	if (units == "MT CO₂" && window.PORTAL_COUNTRY == "USA"){
		units = "Tons CO₂";
	}

	return <ViewStatBlock>
		<FlexBlock className="stat"><Icon icon={icon} fType={fType || "fal"} colour={color} size={24}/>
			 <StatLabel className="stat-label">{label}</StatLabel></FlexBlock>
		<StatValue className="stat-value" style={{color: color}}> {displayValue} {units ? <StatUnits>{units}</StatUnits> : null}</StatValue>
	</ViewStatBlock>
}


export const DateTitle = (props)=>{
	const month = moment(props.month + "-01").format("MMMM YYYY");
	return <StyledLink><BasicText style={{fontSize: 18}}>{month}{props.children ? " " : ""}{props.children}</BasicText></StyledLink>;
}

export const CircleChart = ({children = undefined, data, units = undefined, centeredMetric, centeredUnits = undefined, colorScheme = undefined, margin = undefined, labelFontSize=20, width = undefined, minDisplayAngle=0})=>{
	const theme = useTheme();

	const someColors = ["#7cb5ec", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"]; //["#3366cc","#dc3912","#ff9900","#109618","#990099","#0099c6","#dd4477","#66aa00","#b82e2e","#316395","#3366cc","#994499","#22aa99","#aaaa11","#6633cc","#e67300","#8b0707","#651067","#329262","#5574a6","#3b3eac","#b77322","#16d620","#b91383","#f4359e","#9c5935","#a9c413","#2a778d","#668d1c","#bea413","#0c5922","#743411"];

    const pieData = data
            .filter((row) => row.value > 0)
            .map((row, index) => {				
				return {
                amount: row.value,
                svg: {
                    fill: row.color || someColors[index]
                },
				row: row,
                key: `pie-${index}`,
            }});

			const Labels = (props) => {
				const slices = props.slices;
				if (slices == null){
					return [];
				}
				return slices.map((slice, index) => {
					const { labelCentroid, pieCentroid, data } = slice;
					const anchor = labelCentroid[ 0 ] > 0 ? "start" : "end";

					if (minDisplayAngle > 0){
						const sliceDegrees = (slice.endAngle - slice.startAngle) / 6.28 * 360;
						if (sliceDegrees < minDisplayAngle){
							return null;
						}
					}
					return (
						<G key={ index }>
							<SVGText y={labelCentroid[ 1 ]} x={labelCentroid[ 0 ]} fill="black" fontFamily="Red Hat Display" fontSize={labelFontSize}><TSpan textAnchor={anchor}>{data.row.label}</TSpan></SVGText>
							{data.row.label > "" ? <SVGText y={labelCentroid[ 1 ]+labelFontSize+5} x={labelCentroid[ 0 ]} fill="#666666" fontFamily="Red Hat Display" fontSize={labelFontSize*0.75}><TSpan textAnchor={anchor}>{ niceRound(data.row.value,2) } MT</TSpan></SVGText> : null }
						</G>
					)
				})
			}

		let others = [];
		//				dominantBaseline="central"
		if (centeredMetric){
			others.push(<SVGText
				x={0}
				y={12}
				textAnchor="middle"
				fontSize={"38px"}
				fontWeight={"bold"}
				fontFamily="Red Hat Display"			
				fill={COLORS.grey}
				key="centered-metric"
			>
				{centeredMetric ? niceRound( centeredMetric,1) : null} {centeredUnits}
			</SVGText>);
		}

		let pieWidth = "100%";
		if(width != undefined){
			pieWidth = width;
		}

		let pieStyle = {height: 200, width: pieWidth};
		if (theme.screen == 'desktop'){
			pieStyle = {height: 335, width: pieWidth};
		}
        return <View style={{display: 'flex', alignItems: 'center'}}>
                <PieChart style={pieStyle} 
					data={pieData} 
					valueAccessor={({ item }) => item.amount}
					spacing={0}
					outerRadius={'70%'}
					labelRadius={ '90%' }

				>
					<Labels/>
					{others}
				</PieChart>
            </View>;
}

//const AnimatedG = Animated.createAnimatedComponent(G);


const MouseEvent = ({data, setCurrentDataPoint, mousePosition = [-1,-1], padding, yWidth, bandwidth, x = undefined, y = undefined, spacingOuter, spacingInner, boxPadding = 10, horizontal})=>{
	let hoveredBand = undefined;
    const leftOffset = padding + boxPadding + yWidth;

    const assignHover = (band, idx) =>{
        const innerSpace = parseInt(idx) * spacingInner;
        //top left is [0,0] mouse position - 0 index is top

		const startOfBand = x(idx) + leftOffset + innerSpace + spacingOuter;
		if(startOfBand <= mousePosition[0] && mousePosition[0] <= startOfBand + bandwidth){
			hoveredBand = band;
		}
    }

    _.forEach(data, (d, idx)=>{ 
        if(typeof(d) == "object" && d.data != undefined){
            _.forEach(d.data, (dd, ddIdx)=>{
                if(hoveredBand == undefined){
                    assignHover(dd, ddIdx);
                }
            });
        } else {
            if(hoveredBand == undefined){
                assignHover(d, idx);
            }
        }
    });

	if (mousePosition[0] > 0 && mousePosition[1] > 0 ){
		setCurrentDataPoint(hoveredBand);
	}

	return null;
}

const formatChartDate = (d) => {
    if(Util.isMobile()){
        return moment(d).format("MMM");
    }
    return moment(d).format("MMM");
}

export const DiversionHistogram = ({data, maxValue, bandwidth = undefined, defaultDataPoint = undefined, portalData})=>{
	const [mousePosition, setMousePosition] = useState([-1, -1]);
	const [currentDataPoint, setCurrentDataPoint] = useState(null);
	const bound = useMagic({showing: "diversion_percent"});
    const [updating, setUpdating] = useState(false);
	const [data2, setData2] = useState([]);

    useEffect(()=>{
        if(updating){
            setUpdating(false);
        }
    }, [updating]);

    useEffect(()=>{
        bound.magicalState("showing", ()=>setUpdating(true));
    }, [bound]);

	useEffect(()=>{
        if(defaultDataPoint != undefined){
			let rowSum = (defaultDataPoint.waste || 0) + (defaultDataPoint.recycled || 0);
			const diversion = rowSum > 0 ? 100 * parseFloat(defaultDataPoint.recycled || 0) / (parseFloat(rowSum)) : 0;

			const ddp = {'Waste': { value: Util.roundNice(defaultDataPoint.waste, 2) }, 'Recycled': {value: Util.roundNice(defaultDataPoint.recycled, 2)}, "Diversion": {value: diversion}, 'period': formatChartDate(defaultDataPoint.date), all: defaultDataPoint }
            setCurrentDataPoint(ddp);
        }
    }, [defaultDataPoint]);

	useEffect(()=>{
		if (data !=  null){
			const newData = []
			_.each( data, (d)=>{
				let rowSum = (d.waste || 0) + (d.recycled || 0);
				const diversion = rowSum > 0 ? 100 * parseFloat(d.recycled || 0) / (parseFloat(rowSum)) : 0;

				let row = {'Waste': { value: d.waste }, 'Recycled': {value: d.recycled}, "Diversion": {value: diversion}, 'period': formatChartDate(d.date), all: d };
	
				if(rowSum > maxSum){
					maxSum = rowSum;
				}
				
				newData.push( row );
			});

			setData2(newData);
		}
	}, [data]);

    
	let maxSum = 0;

    const colors = [ COLORS.blue2, COLORS.navy ];

	const CrazyMouse = (e)=>{
		let position = undefined;
        if(Util.isMobile()){
            position = {left: e.nativeEvent.locationX, top: e.nativeEvent.locationY};
        } else {
            const rect = e.currentTarget.getBoundingClientRect();
            position = {left: Math.floor(e.clientX - rect.left), top: Math.floor(e.clientY - rect.top) };
        }
        
		setMousePosition([position.left, position.top]);
	};

	const extraProps = {};

    if( !Util.isMobile() ){
        extraProps.onMouseMove = (e)=>CrazyMouse(e);
    }

	let tempData = [];

	if(data2 != undefined && data2.length > 0){
		if(typeof(data2[0]) == "object" && data2[0].data != undefined){
			tempData = _.flatten(_.map(data2, "data"));
		} else {
			tempData = data2;
		}
	} else {
		tempData = [];
	}

	let keys = ['Recycled', 'Waste'];
	if(bound.magicalGet("showing") == "diversion_percent"){
		keys = ['Diversion'];
	}
	const xAxisData = tempData;
	const yAxisData = _.map(tempData, (d)=>{
		if(bound.magicalGet("showing") == "diversion_percent"){
			return d['Diversion'].value || 0;
		}
		return (d['Recycled'].value || 0) + (d['Waste'].value || 0);
	});

	const graphPadding = 20;
	const height = 350;
	const yAxisInset = { top: 10, bottom: 10 };
	let xAxisInset = {left: 0, right: 0};
	let xAxisTop = 15;
    let xAxisHeight = 30;
	let chartContentInset = { top: 10, left: 0, right: 0, bottom: 0 };
	const spacingInner = 0.05, spacingOuter = 0.05;
	let xAxisMobileStyle = {};

	if(Util.isMobile()){
		xAxisInset.right = 15;
		xAxisTop = 7;
		xAxisHeight = 40;
		chartContentInset.right = 15;
		xAxisMobileStyle = {rotation: 45, translateX: 10, translateY: 13};
	}

	const style = {height: height};
	const xAxisStyle = {height: xAxisHeight, top: xAxisTop};
	const yAxisStyle = {
		height: height - xAxisHeight - (graphPadding * 2) + yAxisInset.bottom
	};

	const yearRange = [];
    let yearLabel = "";
    if(portalData.dateRange != undefined && portalData.dateRange.length > 0){
        yearRange.push(moment(portalData.dateRange[0]).format("YYYY"));

        const endRange = moment(portalData.dateRange[portalData.dateRange.length-1]).format("YYYY");
        if(endRange != yearRange[0]){
            yearRange.push(endRange);
        }

        yearLabel = yearRange.join(" - ");
    }

	const yAxisWidth = 48;
	const spaceBetweenYAndChart = 10;
	const yLabelWidth = 25;
	const yWidthWithLabel = yAxisWidth + yLabelWidth;

	return <View style={{minWidth: "100%"}}>
		<View style={{flexDirection: "row", flexWrap: "wrap", justifyContent: "space-between", minHeight: (Util.isMobile() ? 0: 65)}}>
			<CrazyLegend2 currentDataPoint={currentDataPoint} data={data2} colors={colors}/>
			<Bound to={bound}>
				<FlexBlock style={{alignItems: "center", justifyContent: "center", paddingTop: (Util.isMobile()? 5 : 0), width: (Util.isMobile() ? "100%" : "initial")}}>
					<InputSelect label="Showing:" flexDirection="row" field="showing" showEmpty={false} options={[{value: "metric_tonnes_diverted", label: "Diverted Materials"}, {value: "diversion_percent", label: "Diversion (%)"}]} pickerStyle={{minWidth: Util.isMobile() ? 200: 140}}/>
				</FlexBlock>
			</Bound>	
		</View>
		<View style={{flexDirection: "column"}}>
			<TouchableOpacity style={{ height: height, flexDirection: 'row', padding: graphPadding }} onPress={(e) => CrazyMouse(e)} activeOpacity={1} {...extraProps}>
				<View style={{flexDirection: "row", width: yWidthWithLabel}}>
					<View style={{width: yLabelWidth, justifyContent: "center", alignItems: "center"}}>
						<Svg>
							<Text rotation={270} translateX={Util.isMobile()? 10 : 150} translateY={Util.isMobile()? 180 : 75} text-anchor="middle" fontSize={12} fontFamily="Red Hat Display" fill="grey" fontWeight={500} letterSpacing={0.5}>
								{bound.magicalGet("showing") == "diversion_percent" ? "Diversion (%)" : "Metric Tonnes"}
							</Text>
						</Svg>
					</View>
					<YAxis
						data={yAxisData}
						contentInset={yAxisInset}
						style={yAxisStyle}
						formatLabel={(v,i)=>{ return (i % 2 == 1? "" : v)}}
						svg={{fontSize: 12, fill: 'grey', fontFamily: 'Red Hat Display'}}
						spacingInner={spacingInner}
						spacingOuter={spacingOuter}
						scale={scale.scaleLinear}
						min={0}
					/>
				</View>
				<View style={{flex: 1, marginLeft: spaceBetweenYAndChart}}>
					<StackedBarChart
						style={{ ...{ flex: 1 }, ...style }}
						gridMin={0}
						yMax={maxSum}
						colors={colors}
						contentInset={chartContentInset}
						height={style.height}
						data={data2}
						spacingInner={spacingInner}
                    	spacingOuter={spacingOuter}
						keys={keys}
						valueAccessor={(r) => { return r.item[r.key].value }}
					>
							<MouseEvent data={data2} horizontal={false} yWidth={yLabelWidth + yAxisWidth} boxPadding={10} spacingInner={0.05} spacingOuter={0.05} bandwidth={bandwidth} mousePosition={mousePosition} padding={graphPadding} setCurrentDataPoint={(dp) => { _.isEqual(currentDataPoint, dp) ? null : setCurrentDataPoint(dp) }} />
							<Grid direction={'HORIZONTAL'} svg={{stroke: '#f1f1f1'}}/>
					</StackedBarChart>
					
					<XAxis 
						data={xAxisData} 
						scale={scale.scaleBand}
						formatLabel={(v, i) => { return data2[v].period }} 
						svg={{...{ fontSize: 12, fill: 'grey', fontFamily: 'Red Hat Display'}, ...xAxisMobileStyle}}
						style={xAxisStyle}
						contentInset={xAxisInset}
					/>
				</View>
			</TouchableOpacity>
			<View style={{height: 25, alignItems: "center", marginLeft: yLabelWidth + yAxisWidth + graphPadding + 10 + (Util.isMobile()? 15 : 0), marginRight: graphPadding}}>
				<Svg width={"100%"}>
					<Text x={"50%"} y={"50%"} dominant-baseline="middle" text-anchor="middle" fontSize={12} fontFamily="Red Hat Display" fill="grey" fontWeight={500} letterSpacing={0.5}>
						{yearLabel}
					</Text>
				</Svg>
			</View>
		</View>
	</View>
}

const CrazyLegend2 = ({currentDataPoint, data, colors})=>{
	let diversion = currentDataPoint != null && currentDataPoint['Diversion'] != null ? currentDataPoint['Diversion'].value : null;

	if(_.isNaN(diversion)){
		diversion = 0;
	}
	
	if (currentDataPoint == null) {
		return <FlexBlock style={{ justifyContent: 'flex-start', flexBasis: "auto", height: 35 }}>
		</FlexBlock>;
	}

	const LegendFlexBlock = styled(FlexBlock)`
		justify-content: flex-start;
		align-items: flex-start;
		flex-direction: column;
		flex-wrap: wrap;
	`;

	const ContentChunk = styled.View`
		flex-direction: row;
		margin-horizontal: 5px;
		flex-wrap: wrap;
	`;
	
	return <LegendFlexBlock>
		<ContentChunk style={{marginBottom: 5}}>
			<StrongText>{currentDataPoint == null ? '' : currentDataPoint.all.nicePeriodName}</StrongText>
		</ContentChunk>

		<ContentChunk>
			<View style={{flexDirection: "row"}}>
				<View style={{ height: 20, width: 20, backgroundColor: colors[0], marginRight: 5 }} />
				<View style={{flexDirection: "column", alignItems: "flex-start"}}>
					<StrongText>Recycled</StrongText>
					<StrongText>{currentDataPoint == null ? '' : Util.roundNice(currentDataPoint['Recycled'].value, 2) + " MT"}</StrongText>
				</View>
			</View>

			<View style={{flexDirection: "row"}}>
				<View style={{ height: 20, width: 20, backgroundColor: colors[1], marginHorizontal: 5 }} />
				<View style={{flexDirection: "column", alignItems: "flex-start"}}>
					<StrongText>Landfill</StrongText>
					<StrongText>{currentDataPoint == null ? '' : Util.roundNice(currentDataPoint['Waste'].value, 2) + " MT"}</StrongText>
				</View>
			</View>

			<StrongText style={{marginLeft: 5}}>{diversion != null ? Util.roundNice(diversion, 0) + "% Diverted" : ""}</StrongText>
		</ContentChunk>
	</LegendFlexBlock>;
}

export const MaterialGraph = ({data, units})=>{
	const isUS = window.PORTAL_COUNTRY == "USA";

	const graphData = []; // {label: 'Waste', value: 100, type: 'material' }, {label: 'Cardboard', value: 30, type: 'material' }];
	_.each( data, (d)=>{
		graphData.push( {label: d.name, barDetails: {value: d.metric_tonnes * 1000, svg: {fill: d.main_colour}}, type: 'material', units: isUS ? 'lb' : 'kg' })
	} );
	return <BarGraph width={350} data={graphData} layout="horizontal" keys={['barDetails']} legend={false} height={200} margin={{top: 10, left: 200, right: 80, bottom: 100}} tickValues={8}/>
}


export const BarGraph = ({data, xAxisLabel="", yAxisLabel="", keys, layout, margin=undefined, maxValue = undefined, minValue = undefined, tickValues, width=325, height=300,legend=true,symbol=undefined})=>{
	
	let _margin = margin || {top: 10, left: 75, right: 20, bottom: 100};
	//let labelFormat = null;
	if (layout == "horizontal"){
		_margin = {top: 10, left: 125, right: 40, bottom: 100};
		//labelFormat = (a,b)=>{ return "cheese"; }
	}
	const padding = {};

	const [custom, setCustom] = useState({cheese: 72});
	const container = useRef();
	
	const getColor = (dataRow)=>{
		if (dataRow.color){
			return dataRow.color;
		}

		if (["Waste","Produced"].indexOf(dataRow.label) >= 0){
			return COLORS.grey;
		}
		if (["Recycled"].indexOf(dataRow.label) >= 0){
			//return COLORS.blue;
			return COLORS.wsc_blue;
		}


		if (["2021","Diverted","Saved","Monthly Costs"].indexOf(dataRow.label) >= 0){
			return COLORS.blue2;
		}

		if (["Accumulated Savings"].indexOf(dataRow.label) >= 0){
			return COLORS.teal;
		}
		
		if (["2020","Previous Year","Costs Avoided"].indexOf(dataRow.label) >= 0){
			return COLORS.blue3;
		}

		return '#c00';
	};
	
	
	const axisLeft = {
		// tickSize: 5,
		tickValues: tickValues ? tickValues : 'auto',
		tickPadding: 5,
		tickRotation: 0,
		legend: yAxisLabel,
		legendPosition: 'middle',
		legendOffset: -1 * _margin.left + 20
	};

	if ( symbol == "$"){
		axisLeft.format = (f)=>Format.asCurrency( f )
	}

	let data2 = data;
	//data2[0].svg
	//data2 = [{label:'asdf', amount:40},{label:'asdf2', amount:90, svg: {fill: '#0cc'}}];
	//keys = ['amount'];
	const colors = data2.map( (d,i)=>{ 
		const color = getColor(d);
		// changes label data2[i].svg = {fill: color};
		return color;
	});

	let labelsAndAxis = <XAxis data={data2} scale={scale.scaleBand} style={{ height: 20}} formatLabel={(v,i,a)=>{return v;}} svg={{ fontSize: 9, fill: 'black', fontFamily: 'Red Hat Display' }} contentInset={{ top: 20, bottom: 20 }}/>;
	let otherAxis = null;

	if (layout == "horizontal"){
		labelsAndAxis = null; //<XAxis data={data2} scale={scale.scaleLinear} style={{ height: 20}} xAccessor={(r) => { return r.item.barDetails.value }} formatLabel={(v,i)=>{ return Util.roundNice(v,2) }} svg={{ fontSize: 9, fill: 'black', fontFamily: 'Red Hat Display' }} contentInset={{ top: 20, bottom: 20 }}/>;

		otherAxis = <YAxis
                    data={data2}
                    yAccessor={({ index }) => index}
                    scale={scale.scaleBand}
                    contentInset={{ top: 10, bottom: 10 }}
					svg={{ fontSize: 12, fill: 'black', fontFamily: 'Red Hat Display', textAnchor:'end',x:'100%' }}
                    formatLabel={(_, index) => data[ index ].label}
                />

	}
		

	const Labels = ({  x, y, bandwidth, data }) => (
		data.map((value, index) => (
			<SVGText
				key={ index }
				x={ x(value.barDetails.value) + 10 }
				y={ y(index) + (bandwidth / 2) }
				fontSize={ 12 }
				fill={ 'black'}
				fontFamily="Red Hat Display"			
				alignmentBaseline={ 'middle' }
			>
				{parseInt(Util.round(value.barDetails.value,0)).toLocaleString() + " kg"}
			</SVGText>
		))
	)



	return <View style={ { height: 200, flexDirection: 'column' } }>
		<View style={ { flexDirection: 'row' } }>
		{otherAxis}
		<StackedBarChart
		style={{ height: height, width: width}}
		yMax={maxValue}
		yMin={minValue}
		gridMax={30}
		colors={colors}
		showGrid={false}
		numberOfTicks={6}
		horizontal={layout == "horizontal"}
		contentInset={{ top: 3, bottom: 10, left: 10, right: 70 }}
		//valueAccessor={(r) => { return r.item[r.key].value }}
		data={data2}
		keys={keys}
	>
		{/*<Labels/>*/}
		<Grid direction={'VERTICAL'} svg={{stroke: '#f1f1f1'}}/>
		</StackedBarChart>  
		</View>
	{labelsAndAxis}
	</View>
}

export const ColorBlock = styled.View`
	height:25px;
	width: 25px;
	background-color: ${props => props.color};
`;

export const niceRound = (val, places)=>{
	if(val == undefined){
		val = 0;
	}
	if (val.toFixed){
		return +val.toFixed(places == undefined ? 2 : places);
	}
	
	return val;
};

export const Format = {
	asCurrency: (val)=>{
		return parseFloat(val).toLocaleString('en-us', { style: 'currency', currency: 'USD', maximumFractionDigits: 0});
	}
};


